import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Delete as DeleteIcon, CameraAlt as CameraIcon } from '@mui/icons-material';
import ImageUploader from 'react-image-upload';

// eslint-disable-next-line @typescript-eslint/no-require-imports
require('react-image-upload/dist/index.css');

interface UploadImageProps {
  currentImageUrl?: string | null;
  onFileAdded: (imageFile: any) => void;
  onFileRemoved: () => void;
  height?: number;
  width?: string;
  background?: string;
  borderRadius?: string;
}

const UploadImage: React.FC<UploadImageProps> = ({
  currentImageUrl,
  onFileAdded,
  onFileRemoved,
  height = 150,
  width = '100%',
  background = '#f8fafc',
  borderRadius = '4px',
}) => {
  const [hasNewImage, setHasNewImage] = useState(false);

  const handleFileAdded = (imageFile: any) => {
    console.log('File added:', imageFile);
    onFileAdded(imageFile);
    setHasNewImage(true);
  };

  const handleFileRemoved = () => {
    onFileRemoved();
    setHasNewImage(false);
  };

  const handleDeleteCurrentImage = () => {
    onFileRemoved();
    setHasNewImage(true);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'left', 
      border: '1px solid #e5e7eb', 
      padding: 1,
      borderRadius: borderRadius,
      '& .uploader__container': {
        width: '100%',
        position: 'relative',
        '& .uploader__delete-icon': {
          top: 0,
          right: 0,
          position: 'absolute'
        }
      }
    }}>
      {currentImageUrl && !hasNewImage ? (
        <Box sx={{ 
          width: '100%', 
          height: height, 
          position: 'relative',
          background: background,
          borderRadius: borderRadius,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Box
            component="img"
            src={currentImageUrl}
            alt="Current image"
            sx={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              borderRadius: borderRadius,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              borderRadius: '50%',
              width: 32,
              height: 32,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
            }}
            onClick={handleDeleteCurrentImage}
          >
            <DeleteIcon sx={{ color: '#fff', fontSize: 16 }} />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              },
            }}
            onClick={() => {
              setHasNewImage(true);
            }}
          />
        </Box>
      ) : (
        <ImageUploader
          onFileAdded={handleFileAdded}
          onFileRemoved={handleFileRemoved}
          style={{
            height: height,
            width: width,
            background: background,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          deleteIcon={<DeleteIcon sx={{ color: '#ef4444', fontSize: 20, display: "none", position: 'absolute' }} />}
          uploadIcon={<CameraIcon sx={{ color: '#6b7280', fontSize: 32 }} />}
        />
      )}
    </Box>
  );
};

export default UploadImage;
